'use strict';
const angular = require('angular');

/*@ngInject*/
export function SettingsService($resource) {
  return $resource('/api/settings/:id', {
    name: '@_id'
  },{
    getByName: {
      method: 'GET',
        url: "/api/settings/name/:name"
    },
    getPublicByName: {
      method: 'GET',
        url: "/api/settings/public/name/:name"
    },
    update: {
      method: 'PUT'
    },
    getIdByName: {
      method: 'GET',
      url: "/api/settings/get-id-by-name/:name"
    }
  });
}


export default angular.module('conduu.ap.services.SettingsService', [])
  .factory('SettingsService', SettingsService)
  .name;



// WEBPACK FOOTER //
// ./client/~ap/services/settings/settings.service.js